module.exports = __webpack_public_path__ + "fonts/Lufthansa Text Light.945405c9.woff";